<template>
  <div>
    <v-row align="center" justify="space-between" no-gutters class="mb-1">
      <j-date-picker
        filled
        class="no-before"
        hide-details
        dense
        label=""
        v-model="focus"
      ></j-date-picker>
      <v-row align="center" justify="end" no-gutters>
        <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small>fa-chevron-left</v-icon>
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="next">
          <v-icon small>fa-chevron-right</v-icon>
        </v-btn>
        <EventCalendarFilter v-bind.sync="filter"></EventCalendarFilter>
      </v-row>
    </v-row>
    <v-calendar
      v-model="focus"
      :events="events"
      type="month"
      mode="stack"
      ref="calendar"
      locale="fr"
      @click:event="v => $emit('click', v)"
      :event-more="false"
      :start="start"
      :end="end"
      @change="changeDateHandler"
    >
      <template v-slot:day-label="{ date, day, present, past }">
        <v-row no-gutters align="center" justify="space-between">
          <v-row no-gutters align="center">
            <v-btn rounded text icon @click="$emit('clickDate', date)">
              {{ day }}
            </v-btn>
            <span></span>
          </v-row>
          <div v-if="loading === true">
            <v-row no-gutters justify="end">
              <v-progress-circular
                class="mr-1"
                indeterminate
                size="10"
                width="2"
              ></v-progress-circular>
            </v-row>
          </div>
          <div v-else>
            <v-row
              class="chip-space"
              no-gutters
              justify="end"
              v-if="filter.lastYear === true && getLastYear(date) !== null"
            >
              <v-tooltip bottom color="#EF9A9A">
                <template v-slot:activator="{ on }">
                  <v-chip
                    outlined
                    dark
                    label
                    class="mr-1 caption"
                    small
                    v-on="on"
                    color="#EF9A9A"
                    >{{ getLastYear(date) }} $</v-chip
                  >
                </template>
                Année précédente
              </v-tooltip>
            </v-row>
            <v-row
              class="chip-space"
              no-gutters
              justify="end"
              v-if="filter.lastWeek === true && getLastWeek(date) !== null"
            >
              <v-tooltip bottom color="#ffa600">
                <template v-slot:activator="{ on }">
                  <v-chip
                    outlined
                    dark
                    label
                    class="mr-1 caption"
                    small
                    v-on="on"
                    color="#ffa600"
                    >{{ getLastWeek(date) }} $</v-chip
                  >
                </template>
                Semaine précédente
              </v-tooltip>
            </v-row>
            <v-row
              class="chip-space"
              no-gutters
              justify="end"
              v-if="filter.current === true && past && getRealSales(date)"
            >
              <v-tooltip bottom color="#003f5c">
                <template v-slot:activator="{ on }">
                  <v-chip
                    dark
                    label
                    class="mr-1 caption"
                    small
                    v-on="on"
                    color="#003f5c"
                    >{{ getRealSales(date) }} $</v-chip
                  >
                </template>
                Ventes
              </v-tooltip>
            </v-row>
            <v-row
              no-gutters
              justify="end"
              v-if="filter.estimate === true && getIsAdmin === true"
            >
              <EventCalendarEstimateAdder
                :date="date"
                :value="getSalesEstimatesValue(date)"
                @update="$emit('update')"
              ></EventCalendarEstimateAdder>
            </v-row>
          </div>
        </v-row>
      </template>
    </v-calendar>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import EventCalendarFilter from "./EventCalendarFilter";
import EventCalendarEstimateAdder from "./EventCalendarEstimateAdder";
import { round10 } from "round10";
export default {
  name: "EventCalendar",
  components: {
    EventCalendarFilter,
    EventCalendarEstimateAdder
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    start: {
      required: true
    },
    end: {
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getIsAdmin"])
  },
  data() {
    return {
      focus: moment().format("YYYY-MM-DD"),
      title: moment().format("YYYY MMMM"),
      filter: {
        event: true,
        lastYear: true,
        lastWeek: true,
        current: true,
        estimate: true
      }
    };
  },
  methods: {
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    setToday() {
      this.focus = this.today;
    },
    changeDateHandler(v) {
      this.$emit("update:start", v.start.date);
      this.$emit("update:end", v.end.date);
    },
    getItem(date) {
      const d = this.data.find(x => x.date === date);
      return d;
    },
    getLastYear(date) {
      const d = this.data.find(x => x.date === date);
      if (d && d.past_year_sales !== null) return round10(d.past_year_sales, 0);
      return null;
    },
    getLastWeek(date) {
      const d = this.data.find(x => x.date === date);
      if (d && d.last_week_sales !== null) return round10(d.last_week_sales);
      return null;
    },
    getRealSales(date) {
      const d = this.data.find(x => x.date === date);
      if (d && d.sales !== null) return round10(d.sales);
      return null;
    },
    getSalesEstimatesValue(date) {
      const d = this.data.find(x => x.date === date);
      if (d && d.sales_estimates !== null) return round10(d.sales_estimates);
      return null;
    }
  },
  watch: {
    focus(value) {
      this.title = moment(value).format("YYYY MMMM");
    }
  }
};
</script>

<style scoped>
.chip-space {
  margin-bottom: 0.2rem;
}
</style>
